var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bank-journal-hub"},[_c('bank-journal-tenant-tab')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }